import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Info, X } from 'lucide-react';
import './AvvisoRientro.css';

interface AvvisoRientroProps {
  /** Mostrare l'avviso? Lo alza lo store quando rilascia la partita. */
  visibile: boolean;
  onChiudi: () => void;
}

const CHIUSURA_AUTOMATICA_MS = 7000;

/**
 * «La partita è finita mentre eri via.»
 *
 * Chi rientra dopo una lunga assenza trova una stanza che il server non tiene
 * piu' in memoria: non c'e' nessun esito da mostrare, e la damiera va
 * rilasciata. Rilasciarla e riportare alla home in SILENZIO pero' assomiglia a
 * un guasto — la partita sparisce e nessuno dice perche'. Questa e' la riga che
 * mancava.
 */
export default function AvvisoRientro({ visibile, onChiudi }: AvvisoRientroProps) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!visibile) return;
    const id = window.setTimeout(onChiudi, CHIUSURA_AUTOMATICA_MS);
    return () => window.clearTimeout(id);
  }, [visibile, onChiudi]);

  if (!visibile) return null;

  return (
    <div className="avviso-rientro" role="status" data-testid="avviso-rientro">
      <span className="ar-icona" aria-hidden="true"><Info size={16} /></span>
      <span className="ar-testo">
        {t('online.partitaFinitaMentreEriVia', 'The game ended while you were away.')}
      </span>
      <button type="button" className="ar-chiudi" aria-label={t('common.close', 'Close')} onClick={onChiudi}>
        <X size={16} />
      </button>
    </div>
  );
}
